import { Component, inject } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';

import { TerraModule } from '@ninety/terra';
import { StopPropagationDirective, ButtonComponent } from '@ninety/ui/core';

import { MeetingRealTimeActions, MeetingsStateSelectors } from '../..';

@Component({
  selector: 'ninety-meetings-tangent-dialog',
  standalone: true,
  template: `
    <div class="ninety-meeting-tangent-modal" *ngrxLet="componentState$ as state">
      <mat-toolbar class="meeting-tangent__header">
        <div class="meeting-tangent__header-controls">
          <ninety-button flat icon aria-label="Close dialog" (click)="acknowledge()">
            <terra-icon icon="x" />
          </ninety-button>
        </div>
      </mat-toolbar>
      <mat-dialog-content class="meeting-tangent__content" align="center">
        <p class="meeting-tangent__content-title terra-display">Tangent Called!</p>
        <terra-icon class="icon" icon="warning-triangle" size="128" />
        <div class="meeting-tangent__content-description">
          <p class="terra-body">It’s time to get back on topic.</p>
          <p>Create an {{ state.language?.issue?.item }} if the tangent is worth revisiting.</p>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions class="meeting-tangent__actions" align="center">
        <ninety-button
          primary
          filled
          data-cy="meeting-tangent__actions__got-it-button"
          ninetyStopPropagation
          class="meeting-tangent__actions__button full-width"
          (click)="acknowledge()">
          Got it
        </ninety-button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [
    `
      @use 'terra';

      .ninety-meeting-tangent-modal {
        border-radius: terra.radius(medium);
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 540px;
        padding-bottom: 24px;
      }

      .meeting-tangent__header {
        display: flex;
        justify-content: flex-end;
      }

      .meeting-tangent__content,
      .meeting-tangent__actions {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }

      .meeting-tangent__actions {
        max-width: 260px;
        width: 100%;
      }

      p {
        margin: 0;
      }

      .meeting-tangent__content-title {
        color: terra.color('red');
      }

      .meeting-tangent__actions__button {
        border-radius: terra.radius(small);
      }
    `,
  ],
  imports: [StopPropagationDirective, TerraModule, ButtonComponent, MatDialogModule, MatToolbarModule, LetDirective],
})
export class MeetingsTangentDialogComponent {
  private readonly store = inject(Store);
  readonly componentState$ = this.store.select(MeetingsStateSelectors.selectMeetingTangentDialogState);

  acknowledge() {
    this.store.dispatch(MeetingRealTimeActions.tangentDialogClosed());
  }
}
